<button *ngIf="buttonInd" mat-raised-button color="primary" (click)="openUploadDialog()">Upload</button>
<!--<a *ngIf="!buttonInd" (click)="openUploadDialog()" class="list-link"><i class="icon-cloud-upload"></i>&nbsp;Re-Import</a>-->
<a *ngIf="!buttonInd" (click)="openUploadDialog()" class="list-link">Re-Import</a>
